webpackJsonp([36],{

/***/ "/b/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fillcontain",attrs:{"id":""}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4YjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_websocket_vue__ = __webpack_require__("mrxp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d01bc56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_websocket_vue__ = __webpack_require__("ST9p");
function injectStyle (ssrContext) {
  __webpack_require__("9kat")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d01bc56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_websocket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d01bc56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_websocket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9kat":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F+jZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseUrl */
/* unused harmony export main_site_base_url */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return school_name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getQipuList; });
/* unused harmony export userAdd */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return userDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return userUpdate; });
/* unused harmony export getUserInfo */
/* unused harmony export userLoginCheck */
/* unused harmony export Verify */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAdminLogin; });
/* unused harmony export getAdminList */
/* unused harmony export adminAdd */
/* unused harmony export adminDelete */
/* unused harmony export adminUpdate */
/* unused harmony export adminLoginCheck */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAdminInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adminSignout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_js__ = __webpack_require__("YK5A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true;

//const baseUrl = '/';
var baseUrl = __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].getDomain() + '/';
//主站地址，发布时需更改
var main_site_base_url = 'http://wm2.127.com';

var school_name = __WEBPACK_IMPORTED_MODULE_0__global_js__["a" /* default */].school_name;


/* 用户 */
var getUserList = function getUserList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'web_get_user_list', method: 'get', params: params });
};
var getQipuList = function getQipuList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'web_get_qipu_list', method: 'get', params: params });
};

var userAdd = function userAdd(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'user/add', method: 'get', params: params });
};
var userDelete = function userDelete(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'user/delete', method: 'get', params: params });
};
var userUpdate = function userUpdate(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'user/update', method: 'get', params: params });
};
var getUserInfo = function getUserInfo() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'user/info', method: 'get' });
};
var userLoginCheck = function userLoginCheck() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'user/check', method: 'get' });
};

/* 管理员 */
var Verify = function Verify() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'verify', method: 'get' });
};
var checkLogin = function checkLogin() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'checkLogin', method: 'get' });
};
var getAdminLogin = function getAdminLogin(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'admin/login', method: 'post', params: params });
};
var getAdminList = function getAdminList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'admin/list', method: 'get', params: params });
};
var adminAdd = function adminAdd(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'admin/add', method: 'get', params: params });
};
var adminDelete = function adminDelete(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'admin/delete', method: 'get', params: params });
};
var adminUpdate = function adminUpdate(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'admin/update', method: 'get', params: params });
};
var adminLoginCheck = function adminLoginCheck() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'admin/check', method: 'get' });
};
var getAdminInfo = function getAdminInfo() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'admin/info', method: 'get' });
};
var adminSignout = function adminSignout() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ url: baseUrl + 'admin/signout', method: 'get' });
};

// /* 地图 */
// export const getMapList 		=(params)=> {return axios({url:baseUrl+'map/list', 		method:'get', params});};
// export const mapAdd 			=(params)=> {return axios({url:baseUrl+'map/add', 		method:'get', params});};
// export const mapDelete 			=(params)=> {return axios({url:baseUrl+'map/delete', 	method:'get', params});};
// export const mapUpdate 			=(params)=> {return axios({url:baseUrl+'map/update', 	method:'get', params});};
// export const getAllMapCount			=(params)=> {return axios({url:baseUrl+'map/count',		method:'get',params});};

// /* shape */
// export const getShapeList 		=(params)=> {return axios({url:baseUrl+'shape/list', 	method:'get', params});};
// export const shapeAdd 			=(params)=> {return axios({url:baseUrl+'shape/add', 	method:'get', params});};
// export const shapeDelete 		=(params)=> {return axios({url:baseUrl+'shape/delete', 	method:'get', params});};
// export const shapeUpdate 		=(params)=> {return axios({url:baseUrl+'shape/update', 	method:'get', params});};

// /* friend */
// export const getFriendList 		=(params)=> {return axios({url:baseUrl+'friend/list', 	method:'get', params});};
// export const friendAdd 			=(params)=> {return axios({url:baseUrl+'friend/add', 	method:'get', params});};
// export const friendDelete 		=(params)=> {return axios({url:baseUrl+'friend/delete', method:'get', params});};
// export const friendUpdate 		=(params)=> {return axios({url:baseUrl+'friend/update', method:'get', params});};

// /* coop */
// export const getCoopMapList 	=(params)=> {return axios({url:baseUrl+'coopmap/list', 	method:'get', params});};
// export const coopMapAdd 		=(params)=> {return axios({url:baseUrl+'coopmap/add', 	method:'get', params});};
// export const coopMapDelete 		=(params)=> {return axios({url:baseUrl+'coopmap/delete',method:'get', params});};
// export const coopMapUpdate 		=(params)=> {return axios({url:baseUrl+'coopmap/update',method:'get', params});};

// /* data */
// export const getDataList 		=(params)=> {return axios({url:baseUrl+'data/list', 	method:'get', params});};
// export const dataAdd 			=(params)=> {return axios({url:baseUrl+'data/add', 		method:'get', params});};
// export const dataDelete 		=(params)=> {return axios({url:baseUrl+'data/delete', 	method:'get', params});};
// export const dataUpdate 		=(params)=> {return axios({url:baseUrl+'data/update', 	method:'post', params});};
// export const getAllDataCount		=(params)=> {return axios({url:baseUrl+'data/count',		method:'get' ,params});};
// /* classify */
// export const getClassifyList    =(params)=> {return axios({url:baseUrl+'classify/list', 	method:'get', params});};
// export const getClassifyChild    =(params)=> {return axios({url:baseUrl+'classify/getChild', 	method:'get', params});};
// export const classifyAdd 			=(params)=> {return axios({url:baseUrl+'classify/add', 		method:'post', params});};
// export const classifyDelete 		=(params)=> {return axios({url:baseUrl+'classify/delete', 	method:'post', params});};
// export const classifyUpdate 		=(params)=> {return axios({url:baseUrl+'classify/update', 	method:'post', params});};
// export const classifyUpdateSort 		=(params)=> {return axios({url:baseUrl+'classify/update_sort', 	method:'post', params});};
// export const classifyUpdateName		=(params)=> {return axios({url:baseUrl+'classify/update_name', 	method:'post', params});};
// export const classifyUpdateShow		=(params)=> {return axios({url:baseUrl+'classify/update_show', 	method:'post', params});};
// /* statis */
// export const getStatisList 		=(params)=> {return axios({url:baseUrl+'api/statis/list', method:'get', params});};
// export const statisAdd 			=(params)=> {return axios({url:baseUrl+'statis/add', 	method:'get', params});};
// export const statisDelete 		=(params)=> {return axios({url:baseUrl+'statis/delete', method:'get', params});};
// export const statisUpdate 		=(params)=> {return axios({url:baseUrl+'statis/update', method:'get', params});};

// /* 位置 */
// export const guessPlace 		=(params)=> {return axios({url: baseUrl + 'pos/city',	method:'get', params:{type:'guess'}});};
// export const searchPlace 		=(params)=> {return axios({url: baseUrl + 'pos/search',	method:'get', params});};

// /*基本设置*/
// export const SaveConfig		=(params)=> {return axios({url: baseUrl + 'config/save',	method:'post', params});};
// export const getConfig		=()=> {return axios({url: baseUrl + 'config/get_config',	method:'get'});};

// /*文件上传下载*/
// //export const uploadImg 			=(params)=> {return axios({url: baseUrl + 'addimg',		method:'post', params});};
// //export const uploadImg 			=(type)=> {return axios({url: baseUrl + 'addimg/'+type+'/',method:'post', params});};

// /* 统计 当天*/
// export const getTodayApiCount 		=()=> {return axios({url:baseUrl+'api/statis/todayCount',method:'get' });};
// export const getTodayRegUserCount 	=()=> {return axios({url:baseUrl+'api/user/todayCount',	method:'get' });};
// export const getTodayRegAdminCount	=()=> {return axios({url:baseUrl+'api/admin/todayCount',method:'get' });};
// export const getTodayMapCount		=()=> {return axios({url:baseUrl+'api/map/todayCount',	method:'get' });};
// export const getTodayShapeCount		=()=> {return axios({url:baseUrl+'api/shape/todayCount',method:'get' });};
// export const getTodayDataCount		=()=> {return axios({url:baseUrl+'api/data/todayCount',	method:'get' });};

// /* 统计 昨天*/
// export const getYesApiCount			=()=> {return axios({url:baseUrl+'api/statis/yesterdayCount',method:'get' });};
// export const getYesAdminCount		=()=> {return axios({url:baseUrl+'api/admin/yesterdayCount',method:'get' });};
// export const getYesUserCount		=()=> {return axios({url:baseUrl+'api/user/yesterdayCount',	method:'get' });};
// export const getYesMapCount			=()=> {return axios({url:baseUrl+'api/map/yesterdayCount',	method:'get' });};
// export const getYesShapeCount		=()=> {return axios({url:baseUrl+'api/shape/yesterdayCount',method:'get' });};
// export const getYesDataCount		=()=> {return axios({url:baseUrl+'api/data/yesterdayCount',	method:'get' });};

// /* 统计 一周*/
// export const getWeekApiCount		=()=> {return axios({url:baseUrl+'api/statis/weekCount',method:'get' });};
// export const getWeekAdminCount		=()=> {return axios({url:baseUrl+'api/admin/weekCount',	method:'get' });};
// export const getWeekUserCount		=()=> {return axios({url:baseUrl+'api/user/weekCount',	method:'get' });};
// export const getWeekMapCount		=()=> {return axios({url:baseUrl+'api/map/weekCount',	method:'get' });};
// export const getWeekShapeCount		=()=> {return axios({url:baseUrl+'api/shape/weekCount',	method:'get' });};
// export const getWeekDataCount		=()=> {return axios({url:baseUrl+'api/data/weekCount',	method:'get' });};

// /* 统计 一月*/
// export const getMonthApiCount		=()=> {return axios({url:baseUrl+'api/statis/monthCount',method:'get' });};
// export const getMonthAdminCount		=()=> {return axios({url:baseUrl+'api/admin/monthCount',method:'get' });};
// export const getMonthUserCount		=()=> {return axios({url:baseUrl+'api/user/monthCount',	method:'get' });};
// export const getMonthMapCount		=()=> {return axios({url:baseUrl+'api/map/monthCount',	method:'get' });};
// export const getMonthShapeCount		=()=> {return axios({url:baseUrl+'api/shape/monthCount',method:'get' });};
// export const getMonthDataCount		=()=> {return axios({url:baseUrl+'api/data/monthCount',	method:'get' });};

// /* 统计 所有*/
// export const getAllApiCount			=()=> {return axios({url:baseUrl+'api/statis/count',	method:'get' });};
// export const getAllAdminCount		=()=> {return axios({url:baseUrl+'api/admin/count',		method:'get' });};
// export const getAllUserCount		=()=> {return axios({url:baseUrl+'api/user/count',		method:'get' });};

// export const getAllShapeCount		=()=> {return axios({url:baseUrl+'api/shape/count',		method:'get' });};
// export const getAllFriendCount		=()=> {return axios({url:baseUrl+'api/friend/count',	method:'get' });};
// export const getAllCoopMapCount		=()=> {return axios({url:baseUrl+'api/coopmap/count',	method:'get' });};

// export const getAllClassifyCount		=()=> {return axios({url:baseUrl+'api/classify/count',		method:'get' });};
// export const getAllStatisCount		=()=> {return axios({url:baseUrl+'api/statis/count',	method:'get' });};

// /* 统计 某天*/
// export const getDayApiCount			=(today)=> {return axios({url:baseUrl+'api/statis/'+today+'/count',	method:'get'});};
// export const getDayAdminCount		=(today)=> {return axios({url:baseUrl+'api/admin/'+today+'/count',	method:'get'});};
// export const getDayUserCount		=(today)=> {return axios({url:baseUrl+'api/user/'+today+'/count',	method:'get'});};
// export const getDayMapCount			=(today)=> {return axios({url:baseUrl+'api/map/'+today+'/count',	method:'get'});};
// export const getDayShapeCount		=(today)=> {return axios({url:baseUrl+'api/shape/'+today+'/count',	method:'get'});};
// export const getDayDataCount		=(today)=> {return axios({url:baseUrl+'api/data/'+today+'/count',	method:'get'});};

/*
    admin: 	"admin",
    coop: 	"coop_maps",
    friend: "friends",
    map: 	"maps",
    shape: 	"shapes",
    statis: "statistic",
    user: 	"users",
    coopmap:"coop_maps",
    data: 	"data_table",
*/

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_common_js__ = __webpack_require__("F+jZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  adminInfo: {
    id: '0',
    avatar: 'default.png'
  }
};

var mutations = {
  saveAdminInfo: function saveAdminInfo(state, userinfo) {
    state.adminInfo = userinfo;
  }
};

var actions = {
  updateAdminInfo: function updateAdminInfo(_ref) {
    var commit = _ref.commit;

    Object(__WEBPACK_IMPORTED_MODULE_0__common_common_js__["c" /* getAdminInfo */])().then(function (result) {
      console.log(result);
      result = result.data;
      if (result.status === 1) {
        commit('saveAdminInfo', result.data);
      } else {
        console.log('您尚未登陆或者session失效');
      }
    }).catch(function (error) {
      console.log('您尚未登陆或者session失效', error);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions
}));

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96fa4698_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("/b/i");
function injectStyle (ssrContext) {
  __webpack_require__("g1oT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96fa4698_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_css__ = __webpack_require__("5W1q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_websocket_vue__ = __webpack_require__("4YjV");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












//import VueAxios from 'vue-axios'

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('websocket', __WEBPACK_IMPORTED_MODULE_11__components_websocket_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_10_axios___default.a.defaults.withCredentials = true; //跨域保存session有用

//将 axios 赋值给 Vue，方便在子组件里面使用
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$reqs = __WEBPACK_IMPORTED_MODULE_10_axios___default.a;

// 添加响应拦截器
__WEBPACK_IMPORTED_MODULE_10_axios___default.a.interceptors.response.use(function (response) {
	//alert("对响应数据做点什么");
	// 对响应数据做点什么
	//alert(response.data.redirectAdmin);
	if (response.data.err) {
		alert(response.data.err);
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
	} else if (response.data.redirectAdmin) {
		alert("请先登录后台..");
		window.location.href = "#/admin";
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
	} else if (response.data.redirectLogin) {
		alert("请先登录..");
		window.location.href = "#/login";
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
	} else {
		//返回response继续执行后面的操作
		return response;
	}
}, function (error) {
	// 对响应错误做点什么
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
	router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "Qn18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_js__ = __webpack_require__("YK5A");


var socketOpen = false;
var ping = 0;
var Ws = null;
var ws = null;
var send_cache = [];
var pong_time = 0;
var game_id = 0;
var self_color = 0;
var reconn_on = true;
var on_msg_handels = {};
var lockReconnect = false; //避免重复连接

function send(msg) {
	//let eve = msg.event
	//msg = JSON.stringify(msg)
	//if(['ping'].indexOf(msg.event)==-1) send_cache.push(msg)
	//reSend()
	/*uni.sendSocketMessage({
 	data: JSON.stringify(msg),
 	success() {
 		//send_cache.splice(i,1)
 	},
 	fail() {
 
 	}
 });*/
	if (socketOpen) {
		ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(msg));
	} else {
		send_cache.push(msg);
	}
}

function reSend() {
	send_cache.forEach(function (v, k) {
		ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(v));
	});
	/*for(let i in send_cache){
 	//send(send_cache[i])
 	uni.sendSocketMessage({
 		data: JSON.stringify(send_cache[i]),
 		success() {
 			send_cache.splice(i,1)
 		},
 		fail() {
 			
 		}
 	});
 	break;
 }*/
}

function reConnect() {
	if (lockReconnect) return;
	lockReconnect = true;
	ws.close();
	socketOpen = false;
	clearInterval(ping);
	setTimeout(function () {
		pong_time = 0;
		getWebSocket(true);
		lockReconnect = false;
	}, 20);
}

function close() {
	reconn_on = false;
	//clearInterval(ping)
	//uni.closeSocket();
	ws.close();
}

function getWebSocket(is_reconn) {
	reconn_on = true;
	if ("WebSocket" in window) {
		//alert("您的浏览器支持 WebSocket!");

		// 打开一个 web socket
		if (ws == null || is_reconn) ws = new WebSocket("wss://www.weiqi888.com:3011/duiju");
		//if(ws==null || is_reconn) {ws = new WebSocket("wss://localhost:3011/duiju");}

		ws.onopen = function () {
			socketOpen = true;
			reSend();
			if (is_reconn) {
				if (game_id && self_color) Ws.send({
					event: 'reconnect',
					game_id: game_id,
					color: self_color
				});
			}

			setTimeout(function () {
				if (!__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].userInfo) return;
				Ws.send({
					event: 'join_pool',
					user: {
						id: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].userInfo.id,
						school_id: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].userInfo.school_id,
						duiyi_level: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].userInfo.duiyi_level,
						need_pipei: 0,
						name: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].userInfo.name,
						wait: 0,
						reject_list: []
					},
					rev_color: __WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].rev_color,
					game_time: 20,
					b_size: 19
				});
			}, 2000);
		};

		ws.onmessage = function (evt) {
			var res = evt;
			on_msg_handels['global'] = function (res) {
				res = JSON.parse(res.data);
				switch (res.event) {
					case 'po':
						reSend();
						pong_time = new Date().getTime();
						break;
					default:

				}
			};
			for (var i in on_msg_handels) {
				on_msg_handels[i](res);
			}
		};

		ws.onclose = function () {
			console.log('onclose');
			reConnect();
		};
		ws.onerror = function (e) {
			console.log(e);
		};
	} else {
		// 浏览器不支持 WebSocket
		console.error("您的浏览器不支持 WebSocket!");
	}

	ping = setInterval(function () {
		ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ event: 'pi' }));

		var cur_time = new Date().getTime();
		//心跳检测，一段时间没有收到pong,则重连
		if (pong_time > 0 && cur_time - pong_time > 12000) {
			reConnect();
		}
	}, 10000);

	Ws = {
		onMessage: function onMessage(key, cb) {
			on_msg_handels[key] = cb;
		}, //uni.onSocketMessage,
		send: send,
		close: close,
		setGameId: function setGameId(gid) {
			game_id = gid;
		},
		setColor: function setColor(color) {
			self_color = color;
		},
		setReconn: function setReconn(val) {
			clearInterval(ping);
			reconn_on = val;
		}
	};
	__WEBPACK_IMPORTED_MODULE_1__global_js__["a" /* default */].ws = Ws;
	return Ws;
}

function getWs() {
	return Ws;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	getWebSocket: getWebSocket,
	getWs: getWs,
	reConnect: reConnect,
	reSend: reSend
});

/***/ }),

/***/ "ST9p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"title":"提示","visible":_vm.show_tip,"width":"30%"},on:{"update:visible":function($event){_vm.show_tip=$event}}},[_c('span',[_vm._v(_vm._s(_vm.player_name)+"邀请您对弈，是否同意？")]),_vm._v(" "),_c('span',[_vm._v("等级:"+_vm._s(_vm.player_level)+" 获胜:"+_vm._s(_vm.player_win_count)+"场")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.join_game('reject')}}},[_vm._v("拒 绝")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.join_game('ok')}}},[_vm._v("同 意")])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"提示","visible":_vm.show_tip_ww,"width":"30%"},on:{"update:visible":function($event){_vm.show_tip_ww=$event}}},[_c('span',[_vm._v("您有一盘棋未下完，要继续吗？")]),_vm._v(" "),_c('span',[_vm._v("等级:"+_vm._s(_vm.player_level)+" 获胜:"+_vm._s(_vm.player_win_count)+"场")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.join_game_ww('reject')}}},[_vm._v("认 输")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.join_game_ww('ok')}}},[_vm._v("继 续")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YK5A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_websocket_js__ = __webpack_require__("Qn18");

/* harmony default export */ __webpack_exports__["a"] = ({
    domain: 'https://www.weiqi888.com:5707',
    //domain: 'https://localhost:5707',
    version: '1.4.6',
    configJson: 'config.json', //跟工程名称id相同
    userInfo: null,
    levelConfig: null,
    playSound: true,
    pay: false,
    ws: null,
    rev_color: 0,
    school_name: '',
    chess_board_size: 750,
    class_list: [],
    sysInfo: {
        filePath: 'https://www.weiqi888.com:5707/school_image/3/', //文件存储路径
        bookPath: 'https://www.weiqi888.com:5707/school_image/', //文件存储路径
        //dataPath: 'https://localhost:5707',
        dataPath: 'https://www.weiqi888.com:5707',
        fileName: '',
        ext: 'png', //'webp', //默认图片存储后缀为webp
        bigSize: false,
        longSize: true,
        system: 0, //0-表示安卓设备 1-表示苹果设备		
        isUpgrade: false, //表示是否需要升级系统
        selfImg: false, //自定义图片
        width: 0,
        height: 0,
        hwRote: 1,
        isShowChess: true
    },
    changeNameInfo: {
        isShow: false,
        title: '更改备注名',
        placeholder: '请输入备注名',
        text: '',
        key: 'bk_name',
        userId: '',
        page: null
    },
    addTiemInfo: {
        isShow: false,
        title: '增加时长'
    },
    changeWeiqiClassInfo: {
        isShow: false,
        title: '修改级别'
    },
    noticeInfo: {
        isShow: false,
        title: '通知',
        content: '',
        ending: ''
    },
    getDomain: function getDomain() {
        var host = window.location.host;
        var port = window.location.port;
        if (port == '8092') host = host.replace(port, '5707');
        if (!host.includes('5707')) host += ':5707';
        return 'https://' + host;
    },
    init: function init() {
        this.domain = this.getDomain();
        this.dataPath = this.domain;

        this.ws = __WEBPACK_IMPORTED_MODULE_0__common_websocket_js__["a" /* default */].getWebSocket();
        /*let systemInfo = uni.getSystemInfoSync();
        console.log(systemInfo);
        this.sysInfo.width = systemInfo.screenWidth;
        this.sysInfo.height = systemInfo.screenHeight;
        this.sysInfo.bigSize = systemInfo.windowWidth > 500; //判断是否为平板显示设备
        this.sysInfo.hwRote = systemInfo.windowHeight / systemInfo.windowWidth;
        if (this.sysInfo.hwRote < 1.75) this.sysInfo.longSize = false;
        if (systemInfo.system.indexOf("iOS") != -1) {
        	this.sysInfo.system = 1;
        	this.sysInfo.ext = 'png';
        	let sysList = systemInfo.system.split(' ');
        	sysList = sysList[1];
        	let sysVersion = sysList.split('.')
        	sysVersion = parseInt(sysVersion[0]);
        	if (sysVersion < 10) this.sysInfo.isUpgrade = true;
        }
        this.checkUpdate();*/
    },
    setCurrPage: function setCurrPage(page) {
        this.currPage = page;
    },
    checkUpdate: function checkUpdate() {},
    show: function show(obj) {},
    share: function share() {
        var isShare = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    },
    getToday: function getToday() {
        var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        var timestamp = Date.parse(new Date());
        var date = new Date(timestamp);
        //获取年份  
        var Y = date.getFullYear() + year;
        //获取月份  
        var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        //获取当日日期 
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        //console.log("当前时间：" + Y + '年' + M + '月' + D + '日');
        return Y + '-' + M + '-' + D;
    },

    //格式化日期
    formatDate: function formatDate(date, fmt) {
        date = new Date(date);
        var o = {
            "y+": date.getFullYear(),
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((date.getMonth() + 3) / 3),
            "S": date.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(new RegExp("(" + k + ")"), new RegExp("(" + k + ")").length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
        return fmt;
    },

    //得到今天的小时数
    getTodayHours: function getTodayHours() {
        var todayDate = new Date(); //获取系统当前时间
        return todayDate.getHours(); //获取当前小时数(0-23)
    },
    makeTanChuang: function makeTanChuang() {
        var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var agree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
        var reject = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

        return {
            title: title,
            show: show,
            agree: agree,
            reject: reject,
            btn_show: true
        };
    },
    createCanvasContext: function createCanvasContext(id) {
        var c = document.getElementById(id);
        c.width = this.chess_board_size;
        c.height = this.chess_board_size;
        var ctx = c.getContext("2d");
        return ctx;
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



//page
var login = function login(r) {
    return __webpack_require__.e/* require.ensure */(34).then((function () {
        return r(__webpack_require__("Ntyz"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var manage = function manage(r) {
    return __webpack_require__.e/* require.ensure */(27).then((function () {
        return r(__webpack_require__("xoGW"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// const home = r => require.ensure([], () => r(require('@/page/home')), 'home');
var teacher_class = function teacher_class(r) {
    return __webpack_require__.e/* require.ensure */(17).then((function () {
        return r(__webpack_require__("y/K2"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var userlist = function userlist(r) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
        return r(__webpack_require__("Ai5B"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var qipulist = function qipulist(r) {
    return __webpack_require__.e/* require.ensure */(30).then((function () {
        return r(__webpack_require__("qvEx"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var qipu_list = function qipu_list(r) {
    return __webpack_require__.e/* require.ensure */(6).then((function () {
        return r(__webpack_require__("381L"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var cuotiben = function cuotiben(r) {
    return __webpack_require__.e/* require.ensure */(11).then((function () {
        return r(__webpack_require__("A4ZN"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var tk_homework = function tk_homework(r) {
    return __webpack_require__.e/* require.ensure */(15).then((function () {
        return r(__webpack_require__("yapQ"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var student_homework = function student_homework(r) {
    return __webpack_require__.e/* require.ensure */(18).then((function () {
        return r(__webpack_require__("MWLu"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var level = function level(r) {
    return __webpack_require__.e/* require.ensure */(8).then((function () {
        return r(__webpack_require__("O+zI"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var tiku = function tiku(r) {
    return __webpack_require__.e/* require.ensure */(16).then((function () {
        return r(__webpack_require__("+pBz"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var duiju_level = function duiju_level(r) {
    return __webpack_require__.e/* require.ensure */(25).then((function () {
        return r(__webpack_require__("IeIa"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var qipan = function qipan(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__("bgKB"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var duiyiqipan = function duiyiqipan(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__("6J1x"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var school_manage = function school_manage(r) {
    return __webpack_require__.e/* require.ensure */(20).then((function () {
        return r(__webpack_require__("xVLp"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var shenhe = function shenhe(r) {
    return __webpack_require__.e/* require.ensure */(19).then((function () {
        return r(__webpack_require__("pZA5"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var qixiaojianjie = function qixiaojianjie(r) {
    return __webpack_require__.e/* require.ensure */(29).then((function () {
        return r(__webpack_require__("Eir/"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var help = function help(r) {
    return __webpack_require__.e/* require.ensure */(33).then((function () {
        return r(__webpack_require__("o9RY"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var rule = function rule(r) {
    return __webpack_require__.e/* require.ensure */(28).then((function () {
        return r(__webpack_require__("ngDW"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var billboard = function billboard(r) {
    return __webpack_require__.e/* require.ensure */(26).then((function () {
        return r(__webpack_require__("VV5s"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var qimeng_billboard = function qimeng_billboard(r) {
    return __webpack_require__.e/* require.ensure */(22).then((function () {
        return r(__webpack_require__("FRzA"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var qixiao_billboard = function qixiao_billboard(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("4YIa"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var teacher_billboard = function teacher_billboard(r) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
        return r(__webpack_require__("f1Zg"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var pay_card_info = function pay_card_info(r) {
    return __webpack_require__.e/* require.ensure */(23).then((function () {
        return r(__webpack_require__("aAcz"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var billboard_cuoti = function billboard_cuoti(r) {
    return __webpack_require__.e/* require.ensure */(12).then((function () {
        return r(__webpack_require__("ZtA2"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var qimeng = function qimeng(r) {
    return __webpack_require__.e/* require.ensure */(7).then((function () {
        return r(__webpack_require__("S0nC"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var peizhi = function peizhi(r) {
    return __webpack_require__.e/* require.ensure */(31).then((function () {
        return r(__webpack_require__("FonC"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var jiaoxue_peizhi = function jiaoxue_peizhi(r) {
    return __webpack_require__.e/* require.ensure */(32).then((function () {
        return r(__webpack_require__("/Tq5"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var duiyi_user = function duiyi_user(r) {
    return __webpack_require__.e/* require.ensure */(9).then((function () {
        return r(__webpack_require__("QwqO"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var duiju = function duiju(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__("6Iaw"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var index = function index(r) {
    return __webpack_require__.e/* require.ensure */(24).then((function () {
        return r(__webpack_require__("8/c5"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var daguan_list = function daguan_list(r) {
    return __webpack_require__.e/* require.ensure */(10).then((function () {
        return r(__webpack_require__("/mlt"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var setup = function setup(r) {
    return __webpack_require__.e/* require.ensure */(21).then((function () {
        return r(__webpack_require__("lnVj"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var addStudents = function addStudents(r) {
    return __webpack_require__.e/* require.ensure */(13).then((function () {
        return r(__webpack_require__("jNaq"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var bisaibianpai = function bisaibianpai(r) {
    return __webpack_require__.e/* require.ensure */(14).then((function () {
        return r(__webpack_require__("rBs/"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// const maplist = r => require.ensure([], () => r(require('@/page/mapList')), 'mapList');
// const shapelist = r => require.ensure([], () => r(require('@/page/shapeList')), 'shapeList');
// const friendlist = r => require.ensure([], () => r(require('@/page/friendList')), 'friendList');
// const coopmaplist = r => require.ensure([], () => r(require('@/page/coopMapList')), 'coopmapList');
// const datalist = r => require.ensure([], () => r(require('@/page/dataList')), 'dataList');
// const statislist = r => require.ensure([], () => r(require('@/page/statisList')), 'statisList');
// const adduser = r => require.ensure([], () => r(require('@/page/addUser')), 'addUser');
// const addadmin = r => require.ensure([], () => r(require('@/page/addAdmin')), 'addAdmin');
// const addmap = r => require.ensure([], () => r(require('@/page/addMap')), 'addMap');
// const adddata = r => require.ensure([], () => r(require('@/page/addData')), 'addData');
// const info = r => require.ensure([], () => r(require('@/page/info')), 'info');
// const adminset = r => require.ensure([], () => r(require('@/page/adminSet')), 'adminSet');
// const classify = r => require.ensure([], () => r(require('@/page/classify')), 'classify');
// const configSet = r => require.ensure([], () => r(require('@/page/configSet')), 'configSet');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'login',
        component: login
    }, {
        path: '/manage',
        name: '',
        component: manage,
        children: [{
            path: '/index',
            component: index,
            meta: ['首页', '']
        }, {
            path: '/userlist/:class_id',
            component: userlist,
            meta: ['班级管理', '学员列表']
        }, {
            path: '/teacher_class',
            component: teacher_class,
            meta: ['老师班级', '学员列表']
        }, {
            path: '/daguan_list',
            component: daguan_list,
            meta: ['班级管理', '打关列表']
        }, {
            path: '/level',
            component: level,
            meta: ['做题关卡', '关卡列表']
        },, {
            path: '/tiku',
            component: tiku,
            meta: ['题库', '题库列表']
        }, {
            path: '/duiju_level/:id',
            component: duiju_level,
            meta: ['对局关卡', '关卡列表']
        }, {
            path: '/qipulist',
            component: qipulist,
            meta: ['棋谱', '棋谱列表']
        }, {
            path: '/qipu_list',
            component: qipu_list,
            meta: ['棋谱', '棋谱列表']
        }, {
            path: '/cuotiben',
            component: cuotiben,
            meta: ['错题本', '列表']
        }, {
            path: '/tk_homework',
            component: tk_homework,
            meta: ['家庭作业', '列表']
        }, {
            path: '/student_homework',
            component: student_homework,
            meta: ['我的作业', '列表']
        }, {
            path: '/qipan',
            component: qipan,
            meta: ['数据管理', '棋盘']
        }, {
            path: '/duiyiqipan',
            component: duiyiqipan,
            meta: ['数据管理', '棋盘']
        }, {
            path: '/billboard',
            component: billboard,
            meta: ['排行榜', '']
        }, {
            path: '/qimeng_billboard',
            component: qimeng_billboard,
            meta: ['排行榜', '']
        }, {
            path: '/qixiao_billboard',
            component: qixiao_billboard,
            meta: ['棋校排行榜', '']
        }, {
            path: '/teacher_billboard',
            component: teacher_billboard,
            meta: ['老师排行榜', '']
        }, {
            path: '/pay_card_info',
            component: pay_card_info,
            meta: ['购卡详情表', '']
        }, {
            path: '/billboard_cuoti',
            component: billboard_cuoti,
            meta: ['错题榜', '']
        }, {
            path: '/qimeng',
            component: qimeng,
            meta: ['启蒙', '']
        }, {
            path: '/peizhi',
            component: peizhi,
            meta: ['AI', '配置']
        }, {
            path: '/jiaoxue_peizhi',
            component: jiaoxue_peizhi,
            meta: ['教学棋盘', '配置']
        }, {
            path: '/duiyi_user',
            component: duiyi_user,
            meta: ['在线对弈', '在线人员']
        }, {
            path: '/duiju',
            component: duiju,
            meta: ['在线对弈', '']
        }, {
            path: '/setup',
            component: setup,
            meta: ['设置', '']
        }, {
            path: '/addStudents',
            component: addStudents,
            meta: ['班级管理', '添加学员']
        }, {
            path: '/school_manage',
            component: school_manage,
            meta: ['学校管理', '']
        }, {
            path: '/qixiaojianjie',
            component: qixiaojianjie,
            meta: ['棋校简介', '']
        }, {
            path: '/help',
            component: help,
            meta: ['帮助', '']
        }, {
            path: '/bisaibianpai',
            component: bisaibianpai,
            meta: ['比赛编排', '']
        }, {
            path: '/rule',
            component: rule,
            meta: ['围棋规则', '']
        }, {
            path: '/shenhe',
            component: shenhe,
            meta: ['审核', '']
        }]
    }]
}));

/***/ }),

/***/ "g1oT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mrxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_websocket_js__ = __webpack_require__("Qn18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_global_js__ = __webpack_require__("YK5A");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "websocket",
  props: {
    userInfo: {
      type: Object,
      default: __WEBPACK_IMPORTED_MODULE_2__common_global_js__["a" /* default */].userInfo
    },
    /*old_game: {
      type: Object,
      default: null
    },*/
    page: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      sysInfo: __WEBPACK_IMPORTED_MODULE_2__common_global_js__["a" /* default */].sysInfo,
      ws: null,
      duiyi_picker: {
        index: 0,
        array: []
      },
      bannerShow: false,
      bannerShow_pipei: false,
      pipei_djs: 60,
      game_time: 5,
      b_size: 19,
      show_tip: false,
      //show_tip2:false,
      show_tip_ww: false,
      player_name: "",
      player_level: 0,
      player_win_count: 0,
      player_id: 0,
      yaoqing_list: [],
      yq_djs: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    //if (globalData.ws==null) globalData.ws = Ws.getWebSocket()
    this.ws = __WEBPACK_IMPORTED_MODULE_2__common_global_js__["a" /* default */].ws;
    this.ws.onMessage("component_ws", function (res) {
      res = JSON.parse(res.data);
      switch (res.event) {
        case "begin_game":
          localStorage.rev_color = res.color;
          //uni.setStorageSync('rev_color',res.color)
          localStorage.game = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            game_id: res.game_id,
            color: res.color,
            b_size: _this.b_size,
            game_time: _this.game_time
          });
          //uni.setStorageSync('game',{game_id:res.game_id,color:res.color,b_size:this.b_size,game_time:this.game_time})
          //删除定时器
          clearInterval(_this.pp_djs);
          _this.page.yaoqing_win = false;
          _this.$router.push({
            path: "/duiju",
            query: {
              game_id: res.game_id,
              self_color: res.color,
              first_step: res.first_step,
              game_time: _this.game_time,
              b_size: _this.b_size
            }
          });
          /*uni.redirectTo({
          url:'../duiju/duiju?game_id='+res.game_id+'&self_color='+res.color+'&first_step='+res.first_step+'&game_time='+this.game_time+'&b_size='+this.b_size
          })*/
          break;
        case "yaoqing":
          if (_this.show_tip == true) {
            _this.yaoqing_list.push(res);
          } else {
            _this.chuli_yaoqing(res);
          }

          /*this.ws.send({
          event:'re_yaoqing',
          ids:[res.user.id,this.userInfo.id],
          b_size:this.b_size,
          game_time:this.game_time
          })*/

          break;
        case "re_yaoqing":
          //this.show_tip2 = false
          if (_this.page && _this.page.yaoqing_win) _this.page.yaoqing_win = false;
          _this.$message.info("对方拒绝了您的邀请");
          /*uni.showToast({
          title: '对方拒绝了您的邀请',
          mask: false,
          duration: 3000,
          icon:'none'
          });*/
          /*setTimeout(function(){
          if(self.yaoqing_list[0]) {
          let res = self.yaoqing_list[0]
          self.yaoqing_list.splice(0,1)
          self.chuli_yaoqing(res)
          }
          },3000)*/
          break;
        case "game_exist":
          if (res.status == 0) {
            _this.show_tip_ww = true;
          } else {
            localStorage.game = null;
            //uni.setStorageSync('game',null)
          }
          break;
        case "yaoqing_stop":
          clearInterval(_this.yq_djs);
          _this.show_tip = false;
          break;
        default:
      }
    });
    /*setTimeout(()=>{
    this.ws.send({
    	event:'join_pool',
    	user:{
    		id:this.userInfo.id,
    		duiyi_level:this.userInfo.duiyi_level,
    		need_pipei:0,
    		name:this.userInfo.name,
    		wait:0,
    		reject_list:[]
    	},
    	rev_color:globalData.rev_color,
    	game_time:this.game_time,
    	b_size:this.b_size
    })
    },2000)*/
  },

  methods: {
    join_game_ww: function join_game_ww(res) {
      this.old_game = JSON.parse(localStorage.game);
      if (res == "ok") {
        this.$router.push({
          path: "/duiju",
          query: {
            game_id: this.old_game.game_id,
            self_color: this.old_game.color,
            first_step: 0,
            game_time: this.old_game.game_time,
            b_size: this.old_game.b_size,
            type: "reconn"
          }
        });
        this.show_tip_ww = false;
        /*uni.redirectTo({
        url:'../duiju/duiju?game_id='+this.old_game.game_id+'&self_color='+this.old_game.color+'&first_step=0&game_time='+this.old_game.game_time+'&b_size='+this.old_game.b_size+'&type=reconn'
        })*/
      } else {
        this.ws.send({
          event: "region",
          game_id: this.old_game.game_id,
          color: this.old_game.color
        });
        localStorage.game = null;
        //uni.setStorageSync('game',null)
        this.old_game = null;
        this.show_tip_ww = false;
      }
    },
    duiyi_level_mapping: function duiyi_level_mapping(level) {
      level = parseInt(level);
      if (25 - level > 0) {
        return 25 - level + 1 + "级";
      } else {
        return level - 25 + "段";
      }
    },
    chuli_yaoqing: function chuli_yaoqing(res) {
      var _this2 = this;

      this.player_name = res.user.name;
      this.player_id = res.user.id;
      this.player_level = this.duiyi_level_mapping(res.user.duiyi_level);
      this.player_win_count = res.user.win_count;
      this.show_tip = true;
      this.yq_djs = setTimeout(function () {
        _this2.show_tip = false;
        // this.ws.send({
        // 	event:'re_yaoqing',
        // 	res:'reject',
        // 	ids:[this.player_id,this.userInfo.id],
        // 	b_size:this.b_size,
        // 	game_time:this.game_time
        // })
      }, 20000);
    },
    reject_yaoqing_list: function reject_yaoqing_list() {
      for (var i in this.yaoqing_list) {
        this.ws.send({
          event: "re_yaoqing",
          res: "reject",
          ids: [this.yaoqing_list[i].user.id, this.userInfo.id],
          b_size: this.b_size,
          game_time: this.game_time
        });
      }
    },
    join_game: function join_game(res) {
      clearTimeout(this.yq_djs);
      this.ws.send({
        event: "re_yaoqing",
        res: res,
        ids: [this.player_id, this.userInfo.id],
        b_size: this.b_size,
        game_time: this.game_time
      });
      this.show_tip = false;
      if (this.yaoqing_list[0] && res != "ok") {
        var _res = this.yaoqing_list[0];
        this.yaoqing_list.splice(0, 1);
        this.chuli_yaoqing(_res);
      }
    }
  }
});

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fontawesome__ = __webpack_require__("TXBw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_global_js__ = __webpack_require__("YK5A");


//
//
//
//
//
//



/*export default {
  name: 'app'
}*/

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__common_global_js__["a" /* default */].init();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.645b335f679f4ffbafa9.js